import SmallContainer from './SmallContainer';
export default SmallContainer;
